module.exports = __webpack_public_path__ + "img/logo.a79b7c52.png";